// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.service-title{
    position: absolute;
    font-size: 2em;
    font-weight: 300;
    max-width: 10em;
}

.service-title-added {
    font-weight: 100;
    text-transform: uppercase;
}

.service-image-container {
    position: relative;
    width: 100%;
    height: 30em;
    z-index: -1;
}

.service-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.service-properties {
    display: flex;
    gap: 1em;
    margin-top: 1em;
    width: 100%;
    justify-content: space-between;
    align-items: flex-start;
}

.service-property {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 10em;
    align-items: center;
    text-align: center;
}

.service-property-image {
    width: 5em;
    height: 5em;
    object-fit: contain;
}
.service-property-name {
    font-size: 1em;
    font-weight: 100;
    text-transform: uppercase;
}

.service-navigation {
    display: flex;
    width: 100%;
    flex-direction: column;
}

.service-navigation-title{
    position: relative;
    width: 100%;
    font-size: 1em;
    font-weight: 100;
    text-align: center;
}
.service-navigation-title::before {
    content: "";
    position: absolute;
    width: 40%;
    height: 1px;
    border-top: 1px dashed rgba(255, 255, 255, .5);
    top: 50%;
    left: 0;
    transform: translateY(-50%);
}
.service-navigation-title::after {
    content: "";
    position: absolute;
    width: 40%;
    height: 1px;
    border-top: 1px dashed rgba(255, 255, 255, .5);
    top: 50%;
    right: 0;
    transform: translateY(-50%);
}

.service-navigation-arrows {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1em;
    flex-wrap: nowrap;
    padding-bottom: 2.5em;

    border-bottom: 1px dashed rgba(255, 255, 255, .5);
}

.service-navigation-arrows p {
    margin: 0 4em;
    font-weight: 100;
}

.service-navigation-arrow-left,
.service-navigation-arrow-right {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: transform .3s;
}

.service-navigation-arrow-left:hover,
.service-navigation-arrow-right:hover {
    transform: scale(1.1);
}

.project-image-container {
    position: absolute;
    width: 100%;
    height: 100vh;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    margin: 0;
    padding: 0;
}
.project-image-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    mask-image: linear-gradient(rgba(0, 0, 0, 1) 60%, rgba(0, 0, 0, 0));
}

.project-content {
    margin-top: 100vh;
}


@media screen and (max-width: 768px) {
    .service-properties {
        width: 100%;
        max-width: 100%;
    }
    
    .service-property {
        width: 100%;
        justify-content: center;
        align-items: center;
        max-width: 100%;
    }
    
    .service-property-image {
        width: 100%;
        object-fit: contain;
    }

    .service-property-name {
        width: 100%;
        font-size: 1em;
    }
    

    .service-navigation {
        display: flex;
        width: 100%;
        flex-direction: column;
        align-items: center;
    }
    
    .service-navigation-title{
        width: auto;
        background-color: #010840;
        padding: .2em .5em;
        border-radius: 1em;
    }

    .service-navigation-title::before {
        content: "";
        display: none;
    }
    .service-navigation-title::after {
        content: "";
        display: none;
    }
    
    .service-navigation-arrows {
        flex-direction: column;
        margin-top: -2em;
        flex-wrap: nowrap;
        padding-top: 2.5em;
       
        border-top: 1px dashed rgba(255, 255, 255, .5);
        gap: 2em;
    }
    
    .service-navigation-arrows p {
        white-space: nowrap;
    }
    .service-navigation-arrow-left {
        padding-bottom: 2.5em;
        border-bottom: 1px dashed rgba(255, 255, 255, .5);
    }
    .service-navigation-arrow-left,
    .service-navigation-arrow-right  {
        width: 100%;
        justify-content: space-between;
    }

    .service-navigation-arrow-left p,
    .service-navigation-arrow-right p {
        margin: 0;
        order: -1;
    }
    
    .service-navigation-arrow-left:hover,
    .service-navigation-arrow-right:hover {
        transform: scale(1.1);
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/service.css"],"names":[],"mappings":";;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,WAAW;IACX,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,8CAA8C;IAC9C,QAAQ;IACR,OAAO;IACP,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,8CAA8C;IAC9C,QAAQ;IACR,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;;IAErB,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,WAAW;IACX,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;AACd;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mEAAmE;AACvE;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;;IAGA;QACI,aAAa;QACb,WAAW;QACX,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,yBAAyB;QACzB,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;IACA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;;QAElB,8CAA8C;QAC9C,QAAQ;IACZ;;IAEA;QACI,mBAAmB;IACvB;IACA;QACI,qBAAqB;QACrB,iDAAiD;IACrD;IACA;;QAEI,WAAW;QACX,8BAA8B;IAClC;;IAEA;;QAEI,SAAS;QACT,SAAS;IACb;;IAEA;;QAEI,qBAAqB;IACzB;AACJ","sourcesContent":["\n\n.service-title{\n    position: absolute;\n    font-size: 2em;\n    font-weight: 300;\n    max-width: 10em;\n}\n\n.service-title-added {\n    font-weight: 100;\n    text-transform: uppercase;\n}\n\n.service-image-container {\n    position: relative;\n    width: 100%;\n    height: 30em;\n    z-index: -1;\n}\n\n.service-image {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.service-properties {\n    display: flex;\n    gap: 1em;\n    margin-top: 1em;\n    width: 100%;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.service-property {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    max-width: 10em;\n    align-items: center;\n    text-align: center;\n}\n\n.service-property-image {\n    width: 5em;\n    height: 5em;\n    object-fit: contain;\n}\n.service-property-name {\n    font-size: 1em;\n    font-weight: 100;\n    text-transform: uppercase;\n}\n\n.service-navigation {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n}\n\n.service-navigation-title{\n    position: relative;\n    width: 100%;\n    font-size: 1em;\n    font-weight: 100;\n    text-align: center;\n}\n.service-navigation-title::before {\n    content: \"\";\n    position: absolute;\n    width: 40%;\n    height: 1px;\n    border-top: 1px dashed rgba(255, 255, 255, .5);\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n}\n.service-navigation-title::after {\n    content: \"\";\n    position: absolute;\n    width: 40%;\n    height: 1px;\n    border-top: 1px dashed rgba(255, 255, 255, .5);\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n}\n\n.service-navigation-arrows {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 1em;\n    flex-wrap: nowrap;\n    padding-bottom: 2.5em;\n\n    border-bottom: 1px dashed rgba(255, 255, 255, .5);\n}\n\n.service-navigation-arrows p {\n    margin: 0 4em;\n    font-weight: 100;\n}\n\n.service-navigation-arrow-left,\n.service-navigation-arrow-right {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    transition: transform .3s;\n}\n\n.service-navigation-arrow-left:hover,\n.service-navigation-arrow-right:hover {\n    transform: scale(1.1);\n}\n\n.project-image-container {\n    position: absolute;\n    width: 100%;\n    height: 100vh;\n    z-index: -1;\n    top: 0;\n    left: 0;\n    right: 0;\n    margin: 0;\n    padding: 0;\n}\n.project-image-container img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    mask-image: linear-gradient(rgba(0, 0, 0, 1) 60%, rgba(0, 0, 0, 0));\n}\n\n.project-content {\n    margin-top: 100vh;\n}\n\n\n@media screen and (max-width: 768px) {\n    .service-properties {\n        width: 100%;\n        max-width: 100%;\n    }\n    \n    .service-property {\n        width: 100%;\n        justify-content: center;\n        align-items: center;\n        max-width: 100%;\n    }\n    \n    .service-property-image {\n        width: 100%;\n        object-fit: contain;\n    }\n\n    .service-property-name {\n        width: 100%;\n        font-size: 1em;\n    }\n    \n\n    .service-navigation {\n        display: flex;\n        width: 100%;\n        flex-direction: column;\n        align-items: center;\n    }\n    \n    .service-navigation-title{\n        width: auto;\n        background-color: #010840;\n        padding: .2em .5em;\n        border-radius: 1em;\n    }\n\n    .service-navigation-title::before {\n        content: \"\";\n        display: none;\n    }\n    .service-navigation-title::after {\n        content: \"\";\n        display: none;\n    }\n    \n    .service-navigation-arrows {\n        flex-direction: column;\n        margin-top: -2em;\n        flex-wrap: nowrap;\n        padding-top: 2.5em;\n       \n        border-top: 1px dashed rgba(255, 255, 255, .5);\n        gap: 2em;\n    }\n    \n    .service-navigation-arrows p {\n        white-space: nowrap;\n    }\n    .service-navigation-arrow-left {\n        padding-bottom: 2.5em;\n        border-bottom: 1px dashed rgba(255, 255, 255, .5);\n    }\n    .service-navigation-arrow-left,\n    .service-navigation-arrow-right  {\n        width: 100%;\n        justify-content: space-between;\n    }\n\n    .service-navigation-arrow-left p,\n    .service-navigation-arrow-right p {\n        margin: 0;\n        order: -1;\n    }\n    \n    .service-navigation-arrow-left:hover,\n    .service-navigation-arrow-right:hover {\n        transform: scale(1.1);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
